import React, { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { HashLoader } from "react-spinners";
import FadeInAnimation from "../../components/animations/FadeInAnimation";
import Header from "../../components/header/Header";
import { useFetchProfilesQuery } from "../../store/api/apiSlice";

const groupedNavbarData = [
  {
    groupTitle: "Management",
    color: "#ce1126",
    items: [
      { title: "Stats", route: "stats_management" },
      { title: "User Management", route: "user_management" },

      { title: "Colleges Management", route: "colleges_management" },
      { title: "Advertise Management", route: "advertise_management" },
      { title: "Messages to Admin", route: "messages_management" },
      { title: "Banners Management", route: "banners_management" },
      { title: "LiveScores Management", route: "livescores_management" },
      { title: "News Management", route: "news_management" },

      { title: "Sponsor Support Management", route: "raffle_management" },

      { title: "Settings Management", route: "settings_management" },
    ],
  },
  {
    groupTitle: "Data Handling",
    color: "#203864",
    items: [
      { title: "Athletes Management", route: "athlete_management" },
      { title: "News Link", route: "news_link" },
      { title: "News Top Link", route: "news_Top25" },
      { title: "Forum Management", route: "forum_management" },
      { title: "GamePlay Management", route: "gameplay_management" },
      { title: "Key Management", route: "key_management" },
      { title: "Sports Management", route: "sport_management" },
      { title: "University Sport Management", route: "sports_management" },
      { title: "Auto News Statistics", route: "Auto_news_statistics" },
    ],
  },

];

const Admin = () => {
  const navigate = useNavigate();
  const { data: profileData, error, isLoading } = useFetchProfilesQuery();
  const [selectedRoute, setSelectedRoute] = useState("");
  const headerStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    height: "60px",
    backgroundColor: "#fff",
    zIndex: 1000,
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  };

  const containerStyle = {
    display: "flex",
    marginTop: "60px",
  };

  const sideNavStyle = {
    width: "250px",
    backgroundColor: "#ffffff",
    color: "#333",
    position: "fixed",
    top: "60px",
    height: "calc(100vh - 60px)",
    paddingTop: "20px",
    borderRight: "1px solid #ddd",
    overflowY: "auto",
    scrollbarWidth: "thin",
  };

  const groupHeaderStyle = {
    fontWeight: "bold",
    padding: "10px 20px",
    color: "#555",
    borderBottom: "1px solid #ddd",
    marginTop: "10px",
  };

  const navItemStyle = (color, isSelected) => ({
    padding: "10px 20px",
    color: color,
    textDecoration: "none",
    display: "block",
    fontSize: "1rem",
    cursor: "pointer",
    transition: "background 0.3s",
    backgroundColor: isSelected ? "#f0f0f0" : "transparent",
  });

  const navItemHoverStyle = {
    backgroundColor: "#f0f0f0",
  };

  const mainContentStyle = {
    marginLeft: "250px",
    padding: "20px",
    width: "calc(100% - 250px)",
    overflowY: "auto",
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <HashLoader color="#00b386" size={70} />
      </div>
    );
  }

  if (error) {
    return <h1>Error loading profiles.</h1>;
  }

  if (profileData?.user?.isAdmin !== true) {
    navigate("/");
  }

  return (
    <>
      <div style={headerStyle}>
        <FadeInAnimation>
          <Header />
        </FadeInAnimation>
      </div>
      <div style={containerStyle}>
        <nav style={sideNavStyle}>
          {groupedNavbarData.map((group) => (
            <div key={group.groupTitle}>
              <div style={groupHeaderStyle}>{group.groupTitle}</div>
              {group.items.map((item) => (
                <div
                  key={item.route}
                  style={navItemStyle(
                    group.color,
                    selectedRoute === item.route
                  )}
                  onClick={() => {
                    setSelectedRoute(item.route);
                    navigate(`/admin/${item.route}`);
                  }}
                >
                  {item.title}
                </div>
              ))}
            </div>
          ))}
        </nav>
        <main style={mainContentStyle}>
          <Outlet />
        </main>
      </div>
    </>
  );
};

export default Admin;
